export var StateType;

(function (StateType) {
  StateType["UNKNOWN"] = "UNKNOWN";
  StateType["NOT_LOGGED_IN"] = "NOT_LOGGED_IN";
  StateType["LOGGED_IN"] = "LOGGED_IN";
})(StateType || (StateType = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbnVtcy50cyJdLCJuYW1lcyI6WyJTdGF0ZVR5cGUiXSwibWFwcGluZ3MiOiJBQUFBLFdBQVlBLFNBQVo7O1dBQVlBLFM7QUFBQUEsRUFBQUEsUztBQUFBQSxFQUFBQSxTO0FBQUFBLEVBQUFBLFM7R0FBQUEsUyxLQUFBQSxTIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGVudW0gU3RhdGVUeXBlIHtcbiAgVU5LTk9XTiA9ICdVTktOT1dOJyxcbiAgTk9UX0xPR0dFRF9JTiA9ICdOT1RfTE9HR0VEX0lOJyxcbiAgTE9HR0VEX0lOID0gJ0xPR0dFRF9JTicsXG59XG4iXX0=